import { render, staticRenderFns } from "./StadiumBoostUseForm.vue?vue&type=template&id=d6f12c36&"
import script from "./StadiumBoostUseForm.vue?vue&type=script&lang=js&"
export * from "./StadiumBoostUseForm.vue?vue&type=script&lang=js&"
import style0 from "./StadiumBoostUseForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6f12c36')) {
      api.createRecord('d6f12c36', component.options)
    } else {
      api.reload('d6f12c36', component.options)
    }
    module.hot.accept("./StadiumBoostUseForm.vue?vue&type=template&id=d6f12c36&", function () {
      api.rerender('d6f12c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumBoostUseForm.vue"
export default component.exports